import { render, staticRenderFns } from "./warehouse-materials.vue?vue&type=template&id=408071a8"
import script from "./warehouse-materials.vue?vue&type=script&lang=js"
export * from "./warehouse-materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports